import React from 'react'
import { useDispatch } from 'react-redux'
import * as gtag from '../lib/gtag'
import { SHOW_POPUP } from '../store/slices/ui'
import ExperienceProof from './design-system/marketing/ExperienceProof'
import QuotePop from './DeferredQuotePopup'

const HomepageTrustProof = ({
  content,
  image,
  imageAlt,
}) => {
  const dispatch = useDispatch()
  const project = content?.settings?.projectSpotlight

  const openQuote = () => {
    gtag.event({
      action: content?.cta?.eventName || 'home_experience_quote_CTA',
      label: 'leads',
      value: 5,
      category: 'orders'
    })
    dispatch(SHOW_POPUP({ key: 'quote', size: 'medium', body: <QuotePop /> }))
  }

  const trackCorporateProof = () => gtag.event({
    action: content?.settings?.secondaryCta?.eventName || 'home_experience_corporate_CTA',
    label: 'leads',
    value: 2,
    category: 'orders'
  })

  const trackProjectProof = () => gtag.event({
    action: project?.eventName || 'home_experience_project_CTA',
    label: 'portfolio',
    value: 2,
    category: 'engagement'
  })

  return <ExperienceProof
    content={content}
    image={image}
    imageAlt={imageAlt}
    motionProfile='homepage'
    onPrimaryAction={openQuote}
    onProjectAction={trackProjectProof}
    onSecondaryAction={trackCorporateProof}
    project={project}
  />
}

export default HomepageTrustProof
